import { Link } from 'react-router-dom';
import { Zap, Clock, ArrowRight } from 'lucide-react';
import { trainings } from '../data/trainings';

const TrainingsTeaser = () => {
  const liveTrainings = trainings.filter(t => t.status === 'upcoming' || t.status === 'active');
  const threeDayCount = liveTrainings.filter(t => t.duration === '3 Days').length;
  const twoDayCount = liveTrainings.filter(t => t.duration === '2 Days').length;
  const oneDayCount = liveTrainings.filter(t => t.duration === '1 Day').length;

  const TEASER_CARDS = [
    {
      icon: Zap,
      title: `${threeDayCount}× Three-Day Intensives`,
      sub: 'Deep-dive, hands-on tracks for security engineers',
    },
    ...(twoDayCount > 0 ? [{
      icon: Zap,
      title: `${twoDayCount}× Two-Day Intensives`,
      sub: 'Deep-dive, hands-on tracks for security engineers',
    }] : []),
    {
      icon: Clock,
      title: `${oneDayCount}× One-Day Masterclasses`,
      sub: 'Focused, high-impact single-day tracks',
    },
  ];

  return (
    <div>
      <p className="font-mono text-xs uppercase tracking-widest text-[var(--primary)] mb-4">
        Lineup Locked, Details Loading
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {TEASER_CARDS.map(({ icon: Icon, title, sub }) => (
          <div
            key={title}
            className="flex flex-col gap-3 border-2 border-dashed border-[var(--border)] p-6 bg-[var(--surface-highlight)]/20"
          >
            <div className="flex items-center gap-2">
              <Icon className="w-5 h-5 text-[var(--primary)]" />
              <span className="w-2 h-2 bg-[var(--primary)] rounded-full animate-pulse" />
            </div>
            <h3 className="font-mono font-bold text-[var(--text-main)] text-lg">{title}</h3>
            <p className="font-mono text-sm text-[var(--text-muted)]">{sub}</p>
            <p className="font-mono text-xs text-[var(--text-muted)] uppercase tracking-wider mt-auto pt-2 border-t border-[var(--border)]">
              Instructors &amp; topics: Announcing soon
            </p>
          </div>
        ))}
      </div>
      <div className="text-center">
        <Link
          to="/services/quarterly-trainings/register"
          className="group inline-flex items-center gap-2 bg-[var(--primary)] text-black font-mono font-bold px-8 py-3 uppercase tracking-widest hover:bg-[var(--primary-dim)] transition-all duration-200 shadow-[0_0_20px_var(--glow-primary)]"
        >
          Reserve Early Bird Pricing
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default TrainingsTeaser;
